(() => {
  function initSupportExperience(root, form, feedback) {
    const issueButtons = root.querySelectorAll('[data-issue-value]');
    const syncIssueButtons = () => issueButtons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.issueValue === form.elements.defect.value));
    });
    issueButtons.forEach((button) => button.addEventListener('click', () => {
      form.elements.defect.value = button.dataset.issueValue;
      syncIssueButtons();
    }));
    form.elements.defect.addEventListener('change', syncIssueButtons);
    root.querySelectorAll('[data-support-topic]').forEach((link) => link.addEventListener('click', () => {
      if (form.elements.support_subject && !form.elements.support_subject.value.trim()) {
        form.elements.support_subject.value = link.dataset.supportTopic;
      }
      form.elements.defect.value = link.dataset.supportDefect || 'other';
      syncIssueButtons();
    }));
    const search = root.querySelector('[data-support-search]');
    if (search) search.addEventListener('submit', (event) => {
      event.preventDefault();
      const query = search.querySelector('input').value.trim();
      const orderLookup = root.querySelector('[data-order-lookup]');
      if (/^#?(?:NK[ /-]*)?\d[\d /.-]*$/i.test(query)) {
        orderLookup.elements.order_number.value = query;
        orderLookup.elements.order_number.dispatchEvent(new Event('input', { bubbles: true }));
        root.querySelector('#support-order').scrollIntoView({ block: 'center' });
        orderLookup.elements.order_number.focus({ preventScroll: true });
        return;
      }
      const faq = root.querySelector('#support-faq');
      const words = query.toLowerCase().split(/\s+/).filter(Boolean);
      let matches = 0;
      faq.querySelectorAll('details').forEach((item) => {
        const match = !words.length || words.some((word) => item.textContent.toLowerCase().includes(word));
        item.hidden = !match;
        item.open = match && words.length > 0;
        if (match) matches++;
      });
      faq.querySelector('[data-support-search-message]').textContent = words.length
        ? (matches ? matches + ' helpful answers found.' : 'No matching answer. Please contact our team or raise a support ticket.') : '';
      faq.scrollIntoView({ block: 'start' });
    });
    const previews = root.querySelector('[data-photo-previews]');
    const photoInput = form.elements.files;
    if (previews && photoInput && typeof DataTransfer === 'function') {
      let photos = [];
      let previewUrls = [];
      const syncFiles = () => {
        const transfer = new DataTransfer();
        photos.forEach((file) => transfer.items.add(file));
        photoInput.files = transfer.files;
      };
      const renderPreviews = () => {
        previewUrls.forEach((url) => URL.revokeObjectURL(url));
        previewUrls = [];
        previews.replaceChildren();
        photos.forEach((file, index) => {
          const figure = document.createElement('figure');
          figure.className = 'support-file-preview';
          const image = document.createElement('img');
          const url = URL.createObjectURL(file);
          previewUrls.push(url);
          image.src = url;
          image.alt = file.name;
          const caption = document.createElement('figcaption');
          caption.textContent = file.name;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = '\u00d7';
          remove.setAttribute('aria-label', 'Remove ' + file.name);
          remove.addEventListener('click', () => {
            photos.splice(index, 1);
            syncFiles();
            renderPreviews();
          });
          figure.append(image, caption, remove);
          previews.append(figure);
        });
      };
      const addPhotos = (files) => {
        if (form.querySelector('fieldset').disabled) return;
        const candidates = [...photos];
        Array.from(files).forEach((file) => {
          if (!candidates.some((saved) => saved.name === file.name && saved.size === file.size && saved.lastModified === file.lastModified)) candidates.push(file);
        });
        if (candidates.length > 5 || candidates.some((file) => !file.size || file.size > 10 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) || candidates.reduce((sum, file) => sum + file.size, 0) > 25 * 1024 * 1024) {
          feedback.textContent = 'Choose up to 5 JPG, PNG or WebP photos, up to 10 MB each and 25 MB total.';
          syncFiles();
          return;
        }
        photos = candidates;
        syncFiles();
        renderPreviews();
      };
      photoInput.addEventListener('change', () => addPhotos(photoInput.files));
      const dropzone = root.querySelector('[data-photo-dropzone]');
      if (dropzone) {
        dropzone.addEventListener('dragover', (event) => { event.preventDefault(); dropzone.classList.add('is-dragover'); });
        dropzone.addEventListener('dragleave', () => dropzone.classList.remove('is-dragover'));
        dropzone.addEventListener('drop', (event) => {
          event.preventDefault();
          dropzone.classList.remove('is-dragover');
          if (event.dataTransfer) addPhotos(event.dataTransfer.files);
        });
      }
      form.addEventListener('reset', () => {
        photos = [];
        renderPreviews();
        setTimeout(syncIssueButtons, 0);
      });
    }
  }
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-complaint]');
    const fieldset = form.querySelector('fieldset');
    const feedback = root.querySelector('[data-feedback]');
    const service = root.querySelector('[data-service-message]');
    const path = (root.dataset.apiPath || '').replace(/\/$/, '');
    let submitted = false;
    initSupportExperience(root, form, feedback);
    async function api(route, body) {
      const multipart = body instanceof FormData;
      const response = await fetch(path + route, {
        method: 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: multipart ? {} : { 'Content-Type': 'application/json' },
        body: multipart ? body : JSON.stringify(body), signal: AbortSignal.timeout(120000)
      });
      const data = await response.json().catch(() => null);
      if (!response.ok || !data) throw new Error(route === '/orders/lookup' ? (data?.error || 'Unable to fetch order details. Please try again or enter the details manually.') : 'Unable to confirm submission. Contact the store before submitting again.');
      return data;
    }
    function money(value) {
      if (!value || value.amount == null || !Number.isFinite(Number(value.amount)) || !/^[A-Z]{3}$/.test(value.currencyCode)) return '';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: value.currencyCode }).format(Number(value.amount));
      } catch { return value.currencyCode + ' ' + value.amount; }
    }
    const orderLookup = root.querySelector('[data-order-lookup]');
    if (orderLookup) {
      const summary = root.querySelector('[data-order-summary]');
      const pricing = root.querySelector('[data-product-pricing]');
      function clearPricing() {
        if (!pricing) return;
        pricing.hidden = true;
        pricing.querySelector('[data-product-price]').value = '';
        pricing.querySelector('[data-product-amount]').value = '';
      }
      let version = 0;
      let lookupTimer;
      const orderInput = orderLookup.elements.order_number;
      function scheduleLookup() {
        clearTimeout(lookupTimer);
        version++;
        summary.hidden = true;
        clearPricing();
        feedback.textContent = '';
        const number = orderInput.value.trim();
        if (submitted || !/^#?[A-Za-z0-9_./ -]{1,79}$/.test(number) || !/\d/.test(number)) return;
        lookupTimer = setTimeout(() => {
          if (!submitted && !orderInput.disabled && !orderLookup.querySelector('fieldset').disabled) orderLookup.requestSubmit();
        }, 300);
      }
      orderLookup.addEventListener('input', scheduleLookup);
      orderLookup.addEventListener('submit', async (event) => {
        event.preventDefault();
        clearTimeout(lookupTimer);
        if (submitted) return;
        const current = ++version;
        const values = Object.fromEntries(new FormData(orderLookup));
        values.order_number = values.order_number.trim().replace(/^(#?)nk/i, '$1NK');
        const lookupFields = orderLookup.querySelector('fieldset');
        orderLookup.setAttribute('aria-busy', 'true');
        summary.hidden = true;
        clearPricing();
        feedback.textContent = 'Fetching your order...';
        try {
          const { order } = await api('/orders/lookup', values);
          if (current !== version || submitted) return;
          if (!order || !Array.isArray(order.items) || !order.items.length) throw new Error('Order details are incomplete. Enter your details manually.');
          if (typeof order.name === 'string') form.elements.name.value = order.name;
          if (typeof order.email === 'string') form.elements.email.value = order.email;
          form.elements.phone.value = order.phone || '';
          form.elements.order_number.value = order.order_number;
          const select = document.createElement('select');
          select.name = 'product';
          select.required = true;
          select.add(new Option('Choose the affected product', ''));
          order.items.forEach((item) => {
            const price = money(item.unit_price);
            const amount = money(item.amount);
            select.add(new Option(item.title + ' (quantity: ' + item.quantity + ')' +
              (price ? ' - unit price: ' + price : '') + (amount ? ' - amount after discounts: ' + amount : ''), item.title));
          });
          if (order.items.length === 1) select.selectedIndex = 1;
          function showPricing() {
            const item = order.items[select.selectedIndex - 1];
            if (!pricing || !item) { clearPricing(); return; }
            pricing.querySelector('[data-product-price]').value = money(item.unit_price) || 'Unavailable';
            pricing.querySelector('[data-product-amount]').value = money(item.amount) || 'Unavailable';
            pricing.hidden = false;
          }
          select.addEventListener('change', showPricing);
          form.elements.product.replaceWith(select);
          showPricing();
          summary.textContent = 'Order ' + order.order_number + ' - placed ' + new Date(order.created_at).toLocaleDateString() + (money(order.total) ? ' - order total: ' + money(order.total) : '');
          summary.hidden = false;
          feedback.textContent = 'Order details filled. Select the affected product and describe the problem below.' + (!order.email ? ' This order has no email saved; please enter your contact email.' : '');
        } catch (error) {
          if (current === version && !submitted) feedback.textContent = error.message;
        } finally {
          lookupFields.disabled = submitted;
          if (current === version) orderLookup.removeAttribute('aria-busy');
        }
      });
      form.elements.order_number.addEventListener('input', () => {
        version++;
        summary.hidden = true;
        clearPricing();
        orderInput.value = form.elements.order_number.value;
        scheduleLookup();
        const product = form.elements.product;
        if (product.tagName === 'SELECT') {
          const input = document.createElement('input');
          input.name = 'product'; input.maxLength = 200; input.required = true;
          product.replaceWith(input);
        }
      });
    }
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitted) return;
      const values = new FormData(form);
      const subject = String(values.get('support_subject') || '').trim();
      if (subject) values.set('description', 'Subject: ' + subject + '\n\n' + values.get('description'));
      values.delete('support_subject');
      const files = values.getAll('files').filter((file) => file.size);
      if (!files.length || files.length > 5 || files.some((file) => file.size > 10 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) || files.reduce((sum, file) => sum + file.size, 0) > 25 * 1024 * 1024) {
        feedback.textContent = 'Attach 1–5 JPG, PNG or WebP photos, up to 10 MB each and 25 MB total.';
        feedback.focus();
        return;
      }
      const videos = values.getAll('unboxing_video').filter((file) => file.size);
      if (videos.length > 1 || videos.some((file) => file.size > 50 * 1024 * 1024 || !['video/mp4', 'video/quicktime', 'video/webm'].includes(file.type))) {
        feedback.textContent = 'Choose one MP4, MOV or WebM unboxing video, up to 50 MB.';
        feedback.focus();
        return;
      }
      values.set('request_id', crypto.randomUUID());
      submitted = true;
      if (orderLookup) orderLookup.querySelector('fieldset').disabled = true;
      fieldset.disabled = true;
      form.setAttribute('aria-busy', 'true');
      feedback.textContent = 'Submitting your complaint and attachments…';
      try {
        const result = await api('/tickets', values);
        if (result.status !== 'created') throw new Error('Your request was sent, but ticket creation could not be confirmed. Contact the store before submitting again.');
        form.reset();
        feedback.textContent = 'Your complaint and attachments were submitted successfully.' + (result.ticket_id ? ' Ticket number: ' + result.ticket_id + '.' : '') + ' Our team will review your request.';
      } catch (error) {
        feedback.textContent = error.name === 'TimeoutError' ? 'Submission timed out. A ticket may have been created. Contact the store before submitting again.' : error.message;
      } finally {
        form.removeAttribute('aria-busy');
        feedback.focus();
      }
    });
    async function connect() {
      if (!/^\/apps\/[a-zA-Z0-9_/-]+$/.test(path)) {
        service.textContent = 'Online complaints are not available yet. Please contact the store for assistance.';
        return;
      }
      try {
        const health = await api('/health', {});
        if (health.ready !== true) throw new Error();
        service.textContent = '';
        fieldset.disabled = false;
        if (orderLookup) orderLookup.querySelector('fieldset').disabled = false;
      } catch {
        service.textContent = 'The support service is unavailable. Please contact the store or try again later.';
      }
    }
    connect();
  }
  const scan = () => document.querySelectorAll('[data-return-exchange]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
